import React, { useState, useEffect } from 'react';
import { X, Landmark, Coins, ShieldCheck, BadgeDollarSign, CreditCard, TrendingUp, Bitcoin, FileSignature, UserCheck, Settings } from 'lucide-react';
import { useProactiveTips } from '../../hooks/useProactiveTips';

// ============================================
// MAPEAMENTO DE ÍCONES LUCIDE
// ============================================

const iconMap: Record<string, React.ComponentType<{ className?: string; size?: number }>> = {
  Landmark,
  Coins,
  ShieldCheck,
  BadgeDollarSign,
  CreditCard,
  TrendingUp,
  Bitcoin,
  FileSignature,
  UserCheck,
  Settings,
};

// ============================================
// COMPONENTE
// ============================================

export function ProactiveTip() {
  const { getCurrentTip, dismissCurrentTip } = useProactiveTips();
  const tip = getCurrentTip();

  const [visible, setVisible] = useState(false);

  // Controla a animação de entrada quando a dica muda
  useEffect(() => {
    if (tip) {
      // Pequeno delay para garantir que a transição CSS seja aplicada
      const timer = setTimeout(() => setVisible(true), 50);
      return () => clearTimeout(timer);
    }
    setVisible(false);
  }, [tip?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!tip) return null;

  const IconComponent = iconMap[tip.icon];

  const handleDismiss = () => {
    setVisible(false);
    // Aguarda a animação de saída antes de persistir
    setTimeout(() => {
      dismissCurrentTip();
    }, 300);
  };

  return (
    <div
      className="fixed top-20 right-6 z-50"
      style={{ pointerEvents: 'none' }}
    >
      <div
        className={`
          max-w-sm rounded-xl shadow-lg border
          bg-white dark:bg-gray-800
          border-blue-200 dark:border-blue-700
          transition-all duration-300 ease-out
          ${visible
            ? 'opacity-100 translate-x-0'
            : 'opacity-0 translate-x-8'
          }
        `}
        style={{ pointerEvents: 'auto' }}
        role="status"
        aria-live="polite"
      >
        <div className="p-4">
          {/* Header */}
          <div className="flex items-start gap-3">
            {/* Ícone temático */}
            <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-blue-100 dark:bg-blue-900/50 flex items-center justify-center">
              {IconComponent ? (
                <IconComponent className="text-blue-600 dark:text-blue-400" size={20} />
              ) : (
                <Landmark className="text-blue-600 dark:text-blue-400" size={20} />
              )}
            </div>

            {/* Conteúdo */}
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-semibold text-gray-900 dark:text-gray-100">
                {tip.title}
              </h4>
              <p className="mt-1 text-xs text-gray-600 dark:text-gray-400 leading-relaxed">
                {tip.description}
              </p>
            </div>

            {/* Botão dispensar */}
            <button
              onClick={handleDismiss}
              className="flex-shrink-0 p-1 rounded-md text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
              aria-label="Dispensar dica"
            >
              <X size={16} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
